const ProductBatchStocksConstants = {
    SET_PRODUCT_BATCH_STOCKS: 'SET_PRODUCT_BATCH_STOCKS',
    SET_ACTIVE_PRODUCT_BATCH_STOCKS: 'SET_ACTIVE_PRODUCT_BATCH_STOCKS',
    UNSET_ACTIVE_PRODUCT_BATCH_STOCKS: 'UNSET_ACTIVE_PRODUCT_BATCH_STOCKS',
};

export default ProductBatchStocksConstants;
